import { Anchor, Group, Stack } from "@mantine/core";
import { Link } from "react-router-dom";
import { DynamicDashboard } from "../../components/dashboard/DynamicDashboard";
import { PageHeader } from "../../components/ui";
import { NAV_COPY, NAV_ICONS } from "../../lib/navCopy";

export function AdminDashboardPage() {
  return (
    <Stack gap="lg">
      <PageHeader
        icon={NAV_ICONS.dashboard}
        title="Admin Dashboard"
        subtitle="Manage recruiter approvals, company onboarding, and platform activity."
      />

      <DynamicDashboard />

      <Group gap="sm">
        <Anchor component={Link} to="/admin/jobs" className="quickLinkChip">
          <NAV_ICONS.jobs size="var(--axio-unit-16)" />
          {NAV_COPY.admin.jobs}
        </Anchor>
        <Anchor component={Link} to="/admin/applications" className="quickLinkChip">
          <NAV_ICONS.submissions size="var(--axio-unit-16)" />
          {NAV_COPY.common.submissions}
        </Anchor>
        <Anchor component={Link} to="/admin/logs" className="quickLinkChip">
          <NAV_ICONS.logs size="var(--axio-unit-16)" />
          {NAV_COPY.admin.logs}
        </Anchor>
        <Anchor component={Link} to="/admin/recruiters" className="quickLinkChip">
          <NAV_ICONS.recruiters size="var(--axio-unit-16)" />
          {NAV_COPY.common.recruiters}
        </Anchor>
        <Anchor component={Link} to="/admin/companies" className="quickLinkChip">
          {NAV_COPY.sections.companies}
        </Anchor>
      </Group>
    </Stack>
  );
}
